import React from "react";
import CheckBox from "../obra/CheckBox";

const Rubro = ({ completado, className, nombre, showBox }) => {
  return (
    <div className="d-flex align-items-start mx-0">
      {(completado === 1 || showBox) && (
        <span className="flex-shrink-0">
          <CheckBox checked={completado} disabled={true} />
        </span>
      )}
      <span className={`flex-grow-1 ${className || ""}`} style={{ minWidth: 0 }}>
        {nombre && nombre !== null && nombre !== "" ? nombre : "No disponible"}
      </span>
    </div>
  );
};

export default Rubro;
